import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    sexList: [],
};
const getters = {
    getSex: state => state.sexList

};

const mutations = {
    SEX_INFO(state, data) {
        state.sexList = data
    }
};

const actions = {
    getSex({commit}) {
        axiosGet(`crm/sex/status`).then((response) => {
            commit('SEX_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
